import dayjs, { locale } from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek"; // For correct ISO week support
import weekday from "dayjs/plugin/weekday";
import { appointmentsStatus } from "../types/calendar";
// import updateLocale from "dayjs/plugin/updateLocale";
dayjs.extend(weekday);
dayjs.extend(isoWeek);

dayjs.locale("ar");
// dayjs.extend(updateLocale);
// dayjs.updateLocale("en", {
//   weekdays: [
//     "Saturday",
//     "Sunday",
//     "Monday",
//     "Tuesday",
//     "Wednesday",
//     "Thursday",
//     "Friday",
//   ],
//   weekStart: 0,
// });
// dayjs.updateLocale("ar", {
//   weekdays: [
//     "السبت",
//     "الاحد",
//     "الاثنين",
//     "الثلاثاء",
//     "الاربعاء",
//     "الخميس",
//     "الجمعة",
//   ],
//   weekStart: 0,
// });

export function getWeekDate(date: any) {
  return dayjs(date).isoWeek();
}
export const formateTimeToAMPM = (
  time: string,
  currentLang: "en" | "ar" = "ar"
) => {
  try {
    const [h, m] = time?.split(":");
    const ampm =
      Number(h) >= 12
        ? currentLang === "ar"
          ? "مساءً "
          : "PM"
        : currentLang === "ar"
        ? "صباحًا "
        : "AM";
    const h12 = Number(h) % 12 || 12;
    return `${h12 < 10 ? `0${h12}` : h12}:${m} ${ampm}`;
    // return '00:00 AM';
  } catch (error) {
    console.log(error);
  }
};
export function isCurrentWeekFn(date: any) {
  const startOfWeek = dayjs().startOf("week");
  const endOfWeek = dayjs().endOf("week");
  return (
    dayjs(date).isSameOrAfter(startOfWeek) &&
    dayjs(date).isSameOrBefore(endOfWeek)
  );
}
export function formatDateToYYYYMMDD(date: Date) {
  const year = date?.getFullYear();
  const month = String(date.getMonth() + 1)?.padStart(2, "0"); // Adding 1 because months are zero-indexed
  const day = String(date.getDate())?.padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export const weekStart = (date: Date) =>
  dayjs(date).startOf("week").format("YYYY-MM-DD");
export const weekEnd = (date: Date) =>
  dayjs(date).endOf("week").format("YYYY-MM-DD");

export const getWeekDay = (date: Date, currentLang: "en" | "ar" = "ar") => {
  const weekDays =
    currentLang === "ar"
      ? [
          "الأحد",
          "الإثنين",
          "الثلاثاء",
          "الاربعاء",
          "الخميس",
          "الجمعه",
          "السبت",
        ]
      : [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ];
  return weekDays[new Date(date).getDay()];
};

export const getAppointMentStatus = (
  status: appointmentsStatus,
  currentLang: "en" | "ar" = "ar"
) => {
  const AppointmentsStatus = {
    canceled: currentLang === "ar" ? "موعد ملغي" : "Canceled",
    started: currentLang === "ar" ? "قيد التنفيذ" : "On Progress",
    created: currentLang === "ar" ? "موعد قادم" : "Pending",
    completed: currentLang === "ar" ? "موعد مكتمل" : "Completed",
    pending: currentLang === "ar" ? "قيد الانتظار" : "Pending",
    no_show: currentLang === "ar" ? "لم يحضر" : "Did not attend",
    arrived: currentLang === "ar" ? "وصل" : "Arrived",
  } as const;
  return AppointmentsStatus[status];
};

export const getFormatedDayDate = (
  date: Date | string,
  currentLang: "en" | "ar" = "ar",
  yymmdd?: boolean
) => {
  const d = new Date(date);
  if (!d) return;
  if (yymmdd) {
    return `${getWeekDay(new Date(d), currentLang)} - ${formatDateToYYYYMMDD(
      d
    )}`;
  } else {
    const formatedDate = `${getWeekDay(
      new Date(d),
      currentLang
    )} - ${d.getDate()} ${d.toLocaleString(currentLang, {
      month: "long",
    })}`;

    return formatedDate;
  }
};

export const getWeekDays = (date: Date, currentLang: "en" | "ar" = "ar") => {
  // Get the current date
  const currentDate = dayjs(date, { locale: "ar" });
  // Get the start of the current week (Sunday)
  const startOfWeek = currentDate.startOf("week");
  // Create an array to store the days and dates
  const weekDays: { day: string; dayDate: string }[] = [];

  for (let i = 0; i < 7; i++) {
    const day = startOfWeek.add(i, "day");
    weekDays.push({
      day: day.format("dddd"),
      dayDate: day.format("YYYY-MM-DD"),
    });
  }
  return weekDays;
};

export const isDateAndHourInThePast = (date: Date, startTime: string) => {
  const [hours, minutes] = startTime.split(":").map(Number);

  const targetDate = dayjs(date) // Parse the date string using Day.js
    .set("hour", hours) // Set the hours using Day.js's chainable API
    .set("minute", minutes); // Set the minutes using Day.js's chainable API

  const currentDate = dayjs(); // Get the current date using Day.js

  return targetDate.isBefore(currentDate);
};

export function getDesiredDate(date: Date, index: number) {
  const day = getWeekDays(date)[index];
  return new Date(day.dayDate);
}
export function getDurationInMinutes(
  startTime: string,
  finishTime: string
): number {
  // Split the time strings into hours and minutes
  const [startHours, startMinutes] = startTime.split(":").map(Number);
  const [finishHours, finishMinutes] = finishTime.split(":").map(Number);

  // Calculate the total minutes for each time
  const startTotalMinutes = startHours * 60 + startMinutes;
  const finishTotalMinutes = finishHours * 60 + finishMinutes;

  // Handle cases where finish time is before start time
  let duration = finishTotalMinutes - startTotalMinutes;
  if (duration < 0) {
    duration += 24 * 60; // Add total minutes in a day
  }

  return duration;
}
export const getDaysOfWeek = (date: any) => {
  dayjs.locale("en");
  const currentDate = dayjs(date);
  const startOfWeek = currentDate.startOf("week");
  const endOfWeek = currentDate.endOf("week");
  let currentDay = startOfWeek;
  const days = [];

  while (currentDay.isSameOrBefore(endOfWeek)) {
    days.push(currentDay);
    currentDay = currentDay.add(1, "day");
  }

  return days;
};
export function isDateInRange(dateToCheck: any, startDate: any, endDate: any) {
  const date = dayjs(dateToCheck);
  const start = dayjs(startDate);
  const end = dayjs(endDate);

  return date.isSameOrAfter(start) && date.isSameOrBefore(end);
}
